class StepMojoCollectionsCatalogue extends HTMLElement {
  connectedCallback() {
    if (this.dataset.initialized === 'true') return;

    this.dataset.initialized = 'true';
    this.grid = this.querySelector('[data-catalogue-grid]');
    this.items = Array.from(this.querySelectorAll('[data-catalogue-item]'));
    this.filterButtons = Array.from(this.querySelectorAll('[data-catalogue-filter]'));
    this.sortSelect = this.querySelector('[data-catalogue-sort]');
    this.status = this.querySelector('[data-catalogue-status]');
    this.emptyState = this.querySelector('[data-catalogue-empty]');
    this.activeFilter = 'all';
    this.querySelectorAll('.quick-add__button--choose').forEach((button) => {
      button.setAttribute('aria-haspopup', 'dialog');
      button.setAttribute('aria-controls', 'quick-add-dialog');
    });

    this.filterButtons.forEach((button) => {
      button.addEventListener('click', () => this.selectFilter(button));
    });

    this.sortSelect?.addEventListener('change', () => this.render());
    this.render();
  }

  selectFilter(selectedButton) {
    this.activeFilter = selectedButton.dataset.catalogueFilter || 'all';

    this.filterButtons.forEach((button) => {
      const isActive = button === selectedButton;
      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', String(isActive));
    });

    this.render();
  }

  render() {
    if (!this.grid) return;

    const sortValue = this.sortSelect?.value || 'featured';
    const sortedItems = [...this.items].sort((left, right) => {
      if (sortValue === 'title-asc') {
        return left.dataset.title.localeCompare(right.dataset.title);
      }

      if (sortValue === 'price-asc' || sortValue === 'price-desc') {
        const direction = sortValue === 'price-asc' ? 1 : -1;
        return (Number(left.dataset.price) - Number(right.dataset.price)) * direction;
      }

      return Number(left.dataset.featuredIndex) - Number(right.dataset.featuredIndex);
    });

    let visibleCount = 0;

    sortedItems.forEach((item) => {
      const handles = (item.dataset.collections || '').split(/\s+/);
      const isVisible = this.activeFilter === 'all' || handles.includes(this.activeFilter);
      item.hidden = !isVisible;
      this.grid.append(item);
      if (isVisible) visibleCount += 1;
    });

    if (this.emptyState) this.emptyState.hidden = visibleCount !== 0;
    if (this.status) {
      this.status.textContent = `${visibleCount} ${visibleCount === 1 ? 'gift' : 'gifts'} shown.`;
    }
  }
}

if (!customElements.get('stepmojo-collections-catalogue')) {
  customElements.define('stepmojo-collections-catalogue', StepMojoCollectionsCatalogue);
}
